import * as r from 'ramda';
import * as s from './selectors';
import {createSelectorCreator, defaultMemoize} from 'reselect';
import {store} from '../../core';
import * as qs from 'qs';
import URL from 'url-parse';

export const INIT = 'product-configurator.init';
export const ADD_PRODUCT_CONFIG = 'product-configurator.add-pc';
export const REMOVE_PRODUCT_CONFIG = 'product-configurator.remove-pc';
export const TOGGLE_CATEGORY = 'prodct-config.toggle-c';
export const SELECT_VARIANT = 'product-config.sv';
export const NAME_PRODUCT = 'product-config.np';
export const STOP_NAMING_PRODUCT = 'product-config.snp';
export const UPDATE_NAME = 'product-config.un';
export const UPDATE_NAME_ERRORS = 'product-config.une';
export const UPDATE_SAVED_NAME = 'product-config.usn';
export const SHOW_VARIANT_UPGRADE = 'product-config.svu';
export const HIDE_VARIANT_UPGRADE = 'product-config.hvu';
export const SHOW_CONFIGURATION_LIMIT_EXCEEDED = 'product-config.sle';
export const HIDE_CONFIGURATION_LIMIT_EXCEEDED = 'product-config.hle';
export const CANCEL_UPGRADING_VARIANT = 'product-config.cuv';
export const HIDE_VARIANT_DOWNGRADE_INVALID = 'product-config.hvd';

const createSelector = createSelectorCreator(defaultMemoize, r.equals);

let prevHeadXhr = null;

const selectedProductConfigIdsSelector = createSelector(
    s.urlState,
    (urlState) => {
        const url = new URL(window.location.href);
        const originalQuery = qs.parse(r.replace(/^\?/, '', url.query));
        const newQuery = r.mergeRight(originalQuery, urlState);

        url.query = `?${qs.stringify(newQuery)}`;
        const newUrl = url.toString();
        history.replaceState(history.state, document.title, newUrl);
        if (prevHeadXhr) {
            prevHeadXhr.abort();
        }

        // if user logins via oauth, he should be redirected to correct url
        prevHeadXhr = $.ajax({url: location.href, method: 'HEAD'});
    }
);

export function init(options) {
    store.subscribe(() => {
        selectedProductConfigIdsSelector(store.getState());
    });

    return {type: INIT, payload: options};
}

export function addProductConfig(id) {
    return {type: ADD_PRODUCT_CONFIG, payload: id};
}

export function removeProductConfig(id) {
    return {type: REMOVE_PRODUCT_CONFIG, payload: id};
}

export function toggleCategory(category) {
    return {type: TOGGLE_CATEGORY, payload: category};
}

export function selectVariant(variant) {
    return {type: SELECT_VARIANT, payload: variant};
}

export function updateName(name) {
    return {type: UPDATE_NAME, payload: name};
}

export function updateSavedName(name) {
    return {type: UPDATE_SAVED_NAME, payload: name};
}

export function updateNameErrors(errors) {
    return {type: UPDATE_NAME_ERRORS, payload: errors};
}

export function nameProduct() {
    return {type: NAME_PRODUCT};
}

export function stopNamingProduct() {
    return {type: STOP_NAMING_PRODUCT};
}

export function showVariantUpgrade() {
    return {type: SHOW_VARIANT_UPGRADE};
}

export function hideVariantUpgrade() {
    return {type: HIDE_VARIANT_UPGRADE};
}

export function showConfigurationLimitExceeded() {
    return {type: SHOW_CONFIGURATION_LIMIT_EXCEEDED};
}

export function hideConfigurationLimitExceeded() {
    return {type: HIDE_CONFIGURATION_LIMIT_EXCEEDED};
}

export function hideVariantDowngradeInvalid() {
    return {type: HIDE_VARIANT_DOWNGRADE_INVALID};
}

export function upgradeVariant() {
    return function (dispatch, getState) {
        const unrestrictedVariantId = r.path(
            ['productConfigurator', 'unrestrictedVariant'],
            getState()
        );
        dispatch(selectVariant(unrestrictedVariantId));
        dispatch(hideVariantUpgrade());
    };
}

export function cancelUpgradingVariant() {
    return {type: CANCEL_UPGRADING_VARIANT};
}
